/* eslint-disable prettier/prettier */
;
(function (ng) {
  'use strict';

  //$element, $timeout, $window, $scope, cartService, cartConfig, domService, $http, modalService
  var CartMiniCustomCtrl = function ($element, $timeout, $window, $scope, cartService, cartConfig, domService, $http, modalService) {
    var ctrl = this;
    ctrl.df = 123;
    ctrl.urlParams = new URLSearchParams(location.search);
    ctrl.viewCheckoutText = 'viewCheckout';
    ctrl.$onInit = function () {
      ctrl.cartData = {};
      cartService.getData().then(function (data) {
        ctrl.cartData = data;
      });
      let isViewCheckout = ctrl.urlParams.get(ctrl.viewCheckoutText);
      if (isViewCheckout) {
        var cartBtn = $('.site-head-cart[ng-controller="CartMiniCustomCtrl as cart"] a.menu-btn.cart-mini-main');
        if (cartBtn != undefined && cartBtn.length > 0) {
          ctrl.viewModal();
          $timeout(() => {
            ctrl.checkoutPage();
          }, 100);
        } else {
          return;
        }
        console.log(isViewCheckout);
      }
    };
    ctrl.viewModal = () => {
      var options = {
        'modalClass': 'cart-desctop-modal',
        'isOpen': true,
        'destroyOnClose': true,
        'isShowFooter': false,
        'callbackInit': 'cartMini.callbackInit()'
      };
      modalService.renderModal('cartDesctopDetails', null, '<div data-ng-include="\'/Templates/Promo/scripts/_partials/cart/modals/cart-mini-new.html\'"></div>', null, options, {
        cartMini: ctrl
      });
    };
    ctrl.callbackInit = () => {
      $timeout(function () {
        let modal = $('form.adv-modal-inner.cart-desctop-modal');
        modal.addClass('active');
      }, 0);
    };

    //old method

    ctrl.windowScroll = function (event) {
      if (ctrl.checkVisibleCart() === true) {
        $scope.$apply(ctrl.checkFixed);
      }
    };
    ctrl.startTimerClose = function () {
      timer = $timeout(function () {
        ctrl.cartClose();
      }, cartConfig.cartMini.delayHide);
    };
    ctrl.clearTimerClose = function () {
      if (timer != null) {
        $timeout.cancel(timer);
      }
    };
    ctrl.checkFixed = function () {
      ctrl.isCartMiniFixed = $window.pageYOffset > ctrl.staticPosition.top;
    };
    ctrl.clickOut = function (event) {
      var parentCart = domService.closest(event.target, '[data-cart-mini]');
      if (parentCart == null && ctrl.checkVisibleCart() === true) {
        $scope.$apply(function () {
          ctrl.cartClose();
        });
      }
    };
    ctrl.updateAmount = function (value, itemId) {
      var item = {
        Key: itemId,
        Value: value
      };
      cartService.updateAmount([item]);
    };
    ctrl.selectedSize = function (size, offerIdOld) {
      let isShoppingCartItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (isShoppingCartItem == null) return;
      if (size.Amount == 0) return;
      if (size.OfferId == offerIdOld) return;
      $http.post('/cart/setNewOfferOnCart', {
        offerId: size.OfferId,
        offerIdOld: offerIdOld,
        isShoppingCartItem: isShoppingCartItem
      }).then(res => {
        if (isShoppingCartItem) {
          ctrl.getShoppingCart();
        } else {
          ctrl.getShoppingCartNotBuy();
        }
        ctrl.sizeModalView = false;
      });
    };
    ctrl.getShoppingCartNotBuy = () => {
      $http.post('/cart/getShoppingCartNotBuy').then(res => {
        ctrl.shoppingCartNotBye = res.data;
      });
    };
    ctrl.getShoppingCart = () => {
      cartService.getData(Math.random().toString()).then(function (data) {
        ctrl.cartData = data;
        ctrl.loadPointCarouselItems();
        ctrl.viewCheckout = false;
      });
      $http.post('/cart/GetCartSoldOut').then(res => {
        ctrl.shoppingCartSoldOut = res.data;
      });
      let carouselContent = $("div#cartDesctopDetails .cart-desctop-modal .modal-content");
      carouselContent[0].addEventListener('scroll', item => {
        let partCheckout = $(".main-block .col-xs-6.block-checkout-part");
        if (item.currentTarget.scrollTop > 100) {
          partCheckout[0].style.top = item.currentTarget.scrollTop - 100 + 'px';
        } else {
          partCheckout[0].style.top = 0 + 'px';
        }
      });
    };
    ctrl.checkPromoCode = () => {
      $http.post('/Coupon/CouponPost', {
        code: ctrl.promoCode
      }).then(res => {
        if (res.data.result) {
          ctrl.getShoppingCart();
          ctrl.getShoppingCartNotBuy();
        } else {
          ctrl.msgErrorPromoCode = res.data.msg;
        }
      });
    };
    ctrl.deleteCoupon = () => {
      $http.post('/Coupon/DeleteCoupon').then(res => {
        if (res.data) {
          ctrl.getShoppingCart();
          ctrl.getShoppingCartNotBuy();
          ctrl.promoCode = null;
        }
      });
    };
    ctrl.checkoutPage = () => {
      let authBtn = $('.search-block-acc-link[ng-click="auth.openAuthModal()"]');
      if (authBtn != undefined && authBtn.length > 0) {
        authBtn.click();
        const event = new CustomEvent('isCheckoutCart');
        document.dispatchEvent(event);
      } else {
        $http.post('/Checkout/InitOrder').then(data => {
          ctrl.viewCheckout = true;
        });
        //location.replace("checkout");
      }
    };

    ctrl.changeWishItem = function (offerId) {
      let isShoppingCartItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (isShoppingCartItem == null) return;
      $http.post('/cart/changeWishItem', {
        offerId: offerId
      }).then(res => {
        if (isShoppingCartItem) {
          ctrl.getShoppingCart();
        } else {
          ctrl.getShoppingCartNotBuy();
        }
      });
    };
    ctrl.getSizesByOfferId = function (offerId) {
      let isShoppingCartItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (isShoppingCartItem == null) return;
      $http.post('/cart/GetSizeOnProductDesctop', {
        offerId: offerId
      }).then(res => {
        ctrl.productChangeSize = res.data;
        ctrl.sizeListModal = ctrl.productChangeSize.offerSize;
        var options = {
          'modalClass': 'size-block-modal',
          'isOpen': true,
          'destroyOnClose': true,
          'isShowFooter': false
        };
        ctrl.offerIdSelectedSize = offerId;
        ctrl.isShoppingCartItem = isShoppingCartItem;
        modalService.renderModal('modalSizeBlock', null, '<div data-ng-include="\'/Templates/Promo/scripts/_partials/cart/modals/sizemodal_desctop.html\'"></div>', null, options, {
          cartMiniList: ctrl
        });
      });
    };
    ctrl.openPanelSizeBanner = () => {
      var options = {
        'modalClass': 'size-panel-baner',
        'isOpen': true,
        'destroyOnClose': true,
        'isShowFooter': false,
        crossEnable: false
      };
      modalService.renderModal('modalSizeBaner', null, '<div data-ng-include="\'/Templates/Promo/scripts/_partials/cart/modals/panelSizeBanner.html\'"></div>', null, options, {
        cartMiniList: ctrl
      });
    };
    ctrl.changeCartOnCartItem = (offerId, isShoppingCart) => {
      if (isShoppingCart == null) return;
      $http.post('/cart/ChangeCartOnCartItem', {
        offerId: offerId,
        isShoppingCart: isShoppingCart
      }).then(res => {
        ctrl.getShoppingCart();
        ctrl.getShoppingCartNotBuy();
      });
    };
    ctrl.remove = function (shoppingCartItemId) {
      let isShoppingCartItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      //if (isShoppingCartItem == null)
      //    return;

      if (isShoppingCartItem) {
        cartService.removeItem(shoppingCartItemId).then(function (result) {
          PubSub.publish("cart.remove", result.offerId);
          ctrl.getShoppingCart();
        });
      } else if (isShoppingCartItem == null) {
        $http.post('/cart/RemoveShoppingCartSoldOut', {
          itemId: shoppingCartItemId
        }).then(res => {
          ctrl.getShoppingCart();
        });
      } else {
        $http.post('/cart/removeShoppingCartNotBuy', {
          itemId: shoppingCartItemId
        }).then(res => {
          ctrl.getShoppingCartNotBuy();
        });
      }
    };
    ctrl.getCarousel = () => {
      $http.post('/cart/getcarousel').then(res => {
        if (res.data != undefined && res.data.length > 0) {
          ctrl.carouseList = res.data;
          ctrl.selectedCarousel = res.data[0];
          ctrl.loadPointCarouselItems();
        }
      });
    };
    ctrl.loadPointCarouselItems = () => {
      $timeout(() => {
        let widthItem = 142;
        let carouselPhoto = $(".carousel-block .block-additional-carousel .block-product-list .products-selected");
        let carouselViewBlock = carouselPhoto[0];
        let pointItems = Math.ceil((carouselViewBlock.scrollWidth - carouselViewBlock.clientWidth) / widthItem);
        ctrl.pointCarouselItems = [];
        for (let i = 0; i <= pointItems; i++) {
          ctrl.pointCarouselItems.push(i);
        }
        ctrl.pointSelectedCarouselItem = 0;
      }, 0);
    };
    ctrl.setShippingCost = (deliveryCost, totalCost) => {
      ctrl.ShippingCost = deliveryCost;
      ctrl.cartData.TotalPriceCustom = totalCost;
      ctrl.checkoutSelectedShipping = true;
    };
    ctrl.nextCarouselItem = () => {
      let carouselPhoto = $("div#modalSizeBlock .product-info .carousel-photos");
      let carouselPhotoCard = $("div#modalSizeBlock .product-info .carousel-photos .photo");
      let widthCarouseItem = carouselPhotoCard != undefined && carouselPhotoCard != null && carouselPhotoCard.length > 0 ? carouselPhotoCard[0].clientWidth : 425; // window.document.body.offsetWidth * 0.22;
      let carouselPhotoItem = carouselPhoto[0];
      let nextScroll = carouselPhotoItem.scrollLeft + widthCarouseItem;
      carouselPhotoItem.scrollLeft = carouselPhotoItem.scrollWidth <= nextScroll ? 0 : carouselPhotoItem.scrollLeft + widthCarouseItem;
    };
    ctrl.prevCarouselItem = () => {
      debugger;
      let carouselPhoto = $("div#modalSizeBlock .product-info .carousel-photos");
      let carouselPhotoCard = $("div#modalSizeBlock .product-info .carousel-photos .photo");
      let widthCarouseItem = carouselPhotoCard != undefined && carouselPhotoCard != null && carouselPhotoCard.length > 0 ? carouselPhotoCard[0].clientWidth : 425; // window.document.body.offsetWidth * 0.22;
      let carouselPhotoItem = carouselPhoto[0];
      let nextScroll = carouselPhotoItem.scrollLeft - widthCarouseItem;
      carouselPhotoItem.scrollLeft = 0 > nextScroll ? carouselPhotoItem.scrollWidth : carouselPhotoItem.scrollLeft - widthCarouseItem;
    };
    ctrl.nextCarouselAdditionalItem = () => {
      let carouselPhoto = $(".carousel-block .block-additional-carousel .block-product-list .products-selected");
      let carouselPhotoItem = carouselPhoto[0];
      let widthCarouseItem = window.document.body.offsetWidth * 0.26;
      let nextScroll = carouselPhotoItem.scrollLeft + 142; //widthCarouseItem;
      let maxScroll = carouselPhotoItem.scrollWidth - carouselPhotoItem.clientWidth;
      carouselPhotoItem.scrollLeft = maxScroll <= nextScroll ? maxScroll - 50 <= carouselPhotoItem.scrollLeft ? 0 : maxScroll : nextScroll;
      ctrl.pointSelectedCarouselItem = ctrl.pointSelectedCarouselItem == ctrl.pointCarouselItems.length - 1 ? 0 : ctrl.pointSelectedCarouselItem + 1;
    };
    ctrl.prevCarouselAdditionalItem = () => {
      let carouselPhoto = $(".carousel-block .block-additional-carousel .block-product-list .products-selected");
      let carouselPhotoItem = carouselPhoto[0];
      let widthCarouseItem = window.document.body.offsetWidth * 0.26;
      let nextScroll = carouselPhotoItem.scrollLeft - 142; //- widthCarouseItem;
      carouselPhotoItem.scrollLeft = 0 > nextScroll ? carouselPhotoItem.scrollWidth : nextScroll;
      ctrl.pointSelectedCarouselItem = ctrl.pointSelectedCarouselItem == 0 ? ctrl.pointCarouselItems.length - 1 : ctrl.pointSelectedCarouselItem - 1;
    };

    //type
    // 0 - discount
    // 1 - new
    // 2 - best
    // 3 - recommend

    ctrl.checkproductLabel = function (product) {
      let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (product.viewLabels == undefined) product.viewLabels = [];
      if (product.viewLabels.length == 2) {
        if (product.viewLabels[type] != undefined) return product.viewLabels[type];
        return false;
      }
      if (type == 0 && product.DiscountValue > 0) {
        product.viewLabels[type] = true;
        return true;
      }
      if (type == 1 && product.New) {
        product.viewLabels[type] = true;
        return true;
      }
      if (type == 2 && product.Bestseller) {
        product.viewLabels[type] = true;
        return true;
      }
      if (type == 3 && product.Recomend) {
        product.viewLabels[type] = true;
        return true;
      }
      return false;
    };
    ctrl.viewPhotoUpdate = (productId, linkedItem) => {
      if (linkedItem.productId == productId) return;
      $http.post('/cart/updatePhotoOnProduct', {
        productId: linkedItem.productId
      }).then(res => {
        ctrl.productChangeSize.productId = linkedItem.productId;
        ctrl.productChangeSize.photoList = res.data.photoList;
        ctrl.productChangeSize.offerSize = res.data.offerSize;
        ctrl.productChangeSize.productName = res.data.productName;
        ctrl.productChangeSize.selectedSize = res.data.offerSelected;
      });
    };
  };
  angular.module('cart').controller('CartMiniCustomCtrl', CartMiniCustomCtrl);
  CartMiniCustomCtrl.$inject = ['$element', '$timeout', '$window', '$scope', 'cartService', 'cartConfig', 'domService', '$http', 'modalService'];
})(angular);